import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Actions from '@flux/action';
import { Table, Popover } from 'antd';
import {
  getPendingRequest,
  reqUserInfo,
  updateRequestStatus,
} from '@service/apis';

function PendingListTable() {
  const dispatch = useDispatch();
  const [pendingList, setpendingList] = useState([]);

  const fetchPendingList = () => {
    getPendingRequest().then((res) => {
      setpendingList(res.pendingRequestList);
    });
  };

  const handleUpdate = async (id, action) => {
    await updateRequestStatus(id, action);
    fetchPendingList();
    await dispatch(Actions.getWhiteListMemberList());
  };

  const columns = [
    {
      title: 'Requested By',
      dataIndex: 'fullName',
      key: 'fullName',
    },
    {
      title: 'GUID',
      dataIndex: 'guid',
      key: 'guid',
      width: `10%`,
    },
    {
      title: 'Email Address',
      dataIndex: 'email',
      key: 'email',
      width: `18%`,
    },
    {
      title: 'Staff Class',
      dataIndex: 'staffClass',
      key: 'staffClass',
    },
    {
      title: 'PwC Competency',
      dataIndex: 'pwcCompetency',
      key: 'pwcCompetency',
      width: `15%`,
    },
    {
      dataIndex: 'app',
      key: 'app',
      title: 'System Permission',
      width: `15%`,
    },
    {
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: `15%`,
      render: (text) => (
        <div className="pending-action-wrapper">
          <div
            className="pending-action"
            style={{ color: '#22992E' }}
            onClick={() => {
              handleUpdate(text, 'approve');
            }}
          >
            Approve
          </div>
          <div
            className="pending-action"
            style={{ color: '#E0301E' }}
            onClick={() => {
              handleUpdate(text, 'decline');
            }}
          >
            Decline
          </div>
        </div>
      ),
    },
    {
      dataIndex: 'requestReason',
      key: 'requestReason',
      align: 'center',
      width: `5%`,
      render: (text) => (
        <Popover
          content={text}
          title="Request Reason"
          placement="bottomRight"
          // color=''
          overlayStyle={{
            width: 350,
            whiteSpace: 'pre-line',
            wordBreak: 'break-all',
            wordWrap: 'break-word',
          }}
        >
          <span
            className="appkiticon icon-right-chevron-fill a-font-16"
            style={{ color: '#ACACAC' }}
          />
        </Popover>
      ),
    },
  ];

  useEffect(() => {
    fetchPendingList();
  }, []);

  if (pendingList.length == 0) {
    return null;
  }

  return (
    <div className="pending-wrapper">
      <div className="pending-title">Pending Access Requests</div>
      <Table
        dataSource={pendingList}
        columns={columns}
        scroll={{ y: 102 }}
        pagination={false}
      />
    </div>
  );
}

export default PendingListTable;
